module.exports = __webpack_public_path__ + "static/media/icon_delete.e5de3c0a.svg";